module.exports = __webpack_public_path__ + "assets/img/mecha-btn-f1859894.png";